module.exports = __webpack_public_path__ + "static/media/ringback tone.a4e8d61f.mp3";